import { useApiClient } from '@startupquickstart/frontend';
import { useQuery } from '@tanstack/react-query';

/** One team row from GET /events/:id/leaderboard. */
export interface LeaderboardEntry {
  teamId: string;
  teamName: string;
  teamIconName: string;
  teamIconColor: string;
  allianceId: string | null;
  allianceName: string | null;
  allianceColor: string | null;
  totalPoints: number;
  challengesCompleted: number;
  rank: number;
}

export interface LeaderboardData {
  entries: LeaderboardEntry[];
  eventId: string;
  leaderboardVisible: boolean;
  lastUpdated: string;
}

export const EVENT_LEADERBOARD_QUERY_KEY = 'EventLeaderboard';

/** How often the leaderboard re-polls when the socket is down. */
const LEADERBOARD_POLL_INTERVAL_MS = 10_000;

/**
 * Live leaderboard for an event: socket invalidation is the primary
 * refresh signal (see useDisplaySocket); this poll is the fallback.
 */
export function useEventLeaderboard(eventId: string | undefined) {
  const apiClient = useApiClient();
  return useQuery<{ success: boolean; data: LeaderboardData }>({
    queryKey: [EVENT_LEADERBOARD_QUERY_KEY, eventId],
    queryFn: () => apiClient.get(`/events/${eventId}/leaderboard`),
    enabled: Boolean(eventId),
    refetchInterval: LEADERBOARD_POLL_INTERVAL_MS,
    staleTime: 5_000,
  });
}
